import { EntitiesActionFactory } from '../../../shared/utils/redux/entities/entities.actions'
import { CageTypeDefinition } from '../../../shared/remote-services/dtos/cage.dto'

export class CageActions {
  public static cageTypeDefActions = new EntitiesActionFactory<
    CageTypeDefinition,
    void
  >('[CORE] CAGE_TYPE_DEF_ACTIONS')
}
